// src/components/APanel/BookingSettingsCard.jsx
//
// Admin → Instrumente: câte din lecțiile practice ale cursului se fac pe
// poligon (elevii din sectoarele fără poligon le fac primele). Schimbarea se
// aplică doar elevilor noi: fiecare elev își păstrează numărul fixat la prima
// programare.

import React, { useCallback, useEffect, useState } from "react";

import {
   getBookingSettings,
   updateBookingSettings,
} from "../../api/settingsService";

export default function BookingSettingsCard() {
   const [settings, setSettings] = useState(null);
   const [draft, setDraft] = useState("");
   const [busy, setBusy] = useState(false);
   const [feedback, setFeedback] = useState(null);

   const load = useCallback(() => {
      setFeedback(null);
      getBookingSettings()
         .then((data) => {
            setSettings(data);
            setDraft(String(data?.polygonLessons ?? ""));
         })
         .catch((err) => setFeedback({ ok: false, text: err?.message }));
   }, []);

   useEffect(() => {
      load();
   }, [load]);

   const total = Number(settings?.totalLessons) || 30;
   const value = Number(draft);
   const valid = draft.trim() !== "" && Number.isInteger(value) && value >= 0 && value <= total;
   const dirty = settings && String(settings.polygonLessons) !== draft.trim();

   const save = async () => {
      setBusy(true);
      setFeedback(null);
      try {
         const data = await updateBookingSettings(value);
         setSettings(data);
         setDraft(String(data?.polygonLessons ?? value));
         setFeedback({ ok: true, text: "Salvat. Se aplică elevilor care se programează de acum înainte." });
      } catch (err) {
         setFeedback({ ok: false, text: err?.message });
      } finally {
         setBusy(false);
      }
   };

   return (
      <section className="adminOther__section">
         <div className="adminOther__sectionHead">
            <h2>Lecții practice</h2>
            <p>
               Câte din lecțiile practice se fac pe poligon. Elevii din
               sectoarele fără poligon le fac primele. Numărul nou se aplică
               elevilor care se programează prima dată de acum înainte; cei care
               au deja lecții își păstrează numărul.
            </p>
         </div>

         <div className="bookingSettings">
            {!settings && !feedback && (
               <p className="bookingSettings__muted">Se încarcă...</p>
            )}

            {settings && (
               <>
                  <label className="bookingSettings__line">
                     Total <strong>{total}</strong> lecții, din care
                     <input
                        type="number"
                        min={0}
                        max={total}
                        step={1}
                        className="bookingSettings__input"
                        value={draft}
                        disabled={busy}
                        onChange={(e) => setDraft(e.target.value)}
                        aria-label="Lecții pe poligon"
                     />
                     pe poligon.
                  </label>

                  <div className="bookingSettings__actions">
                     <button
                        type="button"
                        className="messageTemplates__btn messageTemplates__btn--primary"
                        disabled={!dirty || !valid || busy}
                        onClick={save}
                     >
                        {busy ? "Se salvează..." : "Salvează"}
                     </button>
                     {!valid && draft.trim() !== "" && (
                        <span className="messageTemplates__error">
                           Alege un număr între 0 și {total}.
                        </span>
                     )}
                  </div>
               </>
            )}

            {feedback?.text && (
               <p className={feedback.ok ? "messageTemplates__ok" : "messageTemplates__error"}>
                  {feedback.text}
               </p>
            )}
         </div>
      </section>
   );
}
